const RandomNumber = (min, max) => {
	return Math.floor(Math.random() * (max - min) + min);
};

export { RandomNumber };
